import type { ActorEvent, Arrangement, Pagination, RecordLikeProtocol } from '@lighthouse/core'
import type { FlowLayoutNode } from '@lighthouse/shared'
import React, { forwardRef, memo } from 'react'

import { HorizontalScrollView } from './HorizontalScrollView'
import { HorizontalWrapView } from './HorizontalWrapView'

interface Props extends React.ComponentPropsWithoutRef<'div'> {
    node: FlowLayoutNode
    anchorId?: string
    itemWidth: number
    title: string
    cols: number
    gap: number
    arrangement: Arrangement
    wrap?: boolean
    readonly?: boolean
    pagination: Pagination
    scale?: number
    canPaginate?: boolean
    enableDrag?: boolean
    sortId?: string
    onLoadMoreData?: (pageNum: number) => Promise<RecordLikeProtocol[]>
    onRecordClick?: (id: string, actorEvent: ActorEvent, record?: RecordLikeProtocol) => Promise<void>
    onUpdateRecord?: (recordId: string, content: RecordLikeProtocol['content']) => Promise<RecordLikeProtocol>
}

export const HorizontalView = memo(
    forwardRef<HTMLDivElement, Props>((props, ref) => {
        const { wrap = false, ...viewProps } = props

        if (wrap) {
            const { node, anchorId, title, itemWidth, gap, arrangement, readonly, enableDrag, sortId, onRecordClick, onUpdateRecord, style } = viewProps
            return (
                <HorizontalWrapView
                    ref={ref}
                    node={node}
                    anchorId={anchorId}
                    title={title}
                    itemWidth={itemWidth}
                    arrangement={arrangement}
                    gap={gap}
                    readonly={readonly}
                    enableDrag={enableDrag}
                    sortId={sortId}
                    onRecordClick={onRecordClick}
                    onUpdateRecord={onUpdateRecord}
                    style={style}
                />
            )
        }

        return <HorizontalScrollView ref={ref} {...viewProps} />
    })
)